const steps = [
  {
    step: '01',
    en: 'ヒアリング',
    ja: 'ヒアリング・コンセプト設計',
    text: 'お客様のブランドイメージや空間の用途、ターゲット層などを丁寧にヒアリングし、理想の香りの方向性を一緒に定めます。',
    image: 'https://storage.readdy-site.link/project_files/27e48727-1dae-4fc1-9b83-7705d94e7eed/448853df-625c-4b8f-babe-ac57d4774848_amymeison_STEP1_Hearing.jpeg?v=05a0c2d6a1664f4934c1f55e5326dfdd https://storage.readdy-site.link/project_files/27e48727-1dae-4fc1-9b83-7705d94e7eed/d7e85e19-4d20-4055-b483-4e6ba6903dab_amymeison_STEP2_Creation.jpeg?v=b34162f073c7d3135ac7f74f5d028899 https://storage.readdy-site.link/project_files/27e48727-1dae-4fc1-9b83-7705d94e7eed/d0d73453-3a45-4690-b6ec-036ff794110b_amymeison_STEP3_Sample.jpeg?v=aabf7deba68746938b9d18c0c555d282 https://storage.readdy-site.link/project_files/27e48727-1dae-4fc1-9b83-7705d94e7eed/8ada9bc4-e842-4bd9-a0c5-959e1eb6fef1_amymeison_STEP4_defuser.jpeg?v=3afefa3bd1d0a86d484fea90628c0373',
  },
  {
    step: '02',
    en: '調香',
    ja: '香りの開発・調合',
    text: 'ヒアリング内容をもとに、専属の調香師がオリジナルの香りを設計・調合します。世界中から厳選した香料を組み合わせ、唯一無二の香りを生み出します。',
    image: 'https://storage.readdy-site.link/project_files/27e48727-1dae-4fc1-9b83-7705d94e7eed/d7e85e19-4d20-4055-b483-4e6ba6903dab_amymeison_STEP2_Creation.jpeg?v=b34162f073c7d3135ac7f74f5d028899',
  },
  {
    step: '03',
    en: 'サンプルご提出',
    ja: '空間演出・機器の設置',
    text: '調合した香りのサンプルをご提出します。実際にお試しいただき、ご要望に応じて微調整を重ねながら最終的な香りを決定します。',
    image: 'https://storage.readdy-site.link/project_files/27e48727-1dae-4fc1-9b83-7705d94e7eed/d0d73453-3a45-4690-b6ec-036ff794110b_amymeison_STEP3_Sample.jpeg?v=aabf7deba68746938b9d18c0c555d282',
  },
  {
    step: '04',
    en: '香りを実装',
    ja: 'アフターサポート',
    text: '香りを空間に実装します。空間の広さや気流を考慮し、最適なディフューザーの位置もご提案。香りが心地よく広がる環境を整えます。',
    image: 'https://storage.readdy-site.link/project_files/27e48727-1dae-4fc1-9b83-7705d94e7eed/8ada9bc4-e842-4bd9-a0c5-959e1eb6fef1_amymeison_STEP4_defuser.jpeg?v=3afefa3bd1d0a86d484fea90628c0373',
  },
];

export default function Flow() {
  return (
    <section id="flow" className="w-full bg-[#F4D6CE] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end gap-6 md:gap-12 mb-16">
          <div className="shrink-0">
            <p className="text-stone-400 text-3xl md:text-4xl font-light tracking-widest">SERVICE</p>
            <h2 className="text-5xl md:text-6xl font-light italic text-stone-900 tracking-tight -mt-1">
              FLOW
            </h2>
          </div>
          <p className="text-stone-500 text-sm leading-relaxed whitespace-nowrap md:pb-2">
            コンセプトメイキングから空間への香りの実装まで、ワンストップでプロデュースします。
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s) => (
            <div key={s.step} className="flex flex-col gap-4">
              {/* Image */}
              <div className="w-full h-48 rounded-xl overflow-hidden">
                <img
                  src={s.image}
                  alt={s.en}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Label */}
              <div className="flex items-center gap-3">
                <span className="bg-stone-900 text-white text-xs tracking-widest px-3 py-1 rounded-full whitespace-nowrap">
                  STEP {s.step}
                </span>
                <div className="flex-1 h-px bg-stone-200" />
              </div>
              {/* Text */}
              <div>
                <h3 className="text-stone-900 text-base font-medium tracking-wide">{s.en}</h3>
                <p className="text-stone-500 text-xs leading-relaxed mt-2">{s.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
